"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBellOffOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M9 13.52v-1.23C9 7.45 11.36 5 16 5a6.94 6.94 0 015.2 1.8l1.44-1.44A9 9 0 0016 3c-5.72 0-9 3.36-9 9.27v1.23c0 3.14-1.32 6.19-3.44 7.29l-.56.26V23a5.72 5.72 0 002-.75c2.49-1.57 4-5.1 4-8.73zM30 2L2 30h2.82l5-5H11c.35 4.1 2.84 5 5 5 1.74 0 4.58-.68 5-5h8v-4.34l-.55-.28C26.29 19.29 25 16.72 25 13.52v-1.23a14.67 14.67 0 00-.19-2.29L30 4.82zM16 28c-1.33 0-2.68-.39-2.95-3H19c-.32 2.61-1.67 3-3 3zm11-6.14V23H11.82L23 11.84v1.68c0 3.71 1.48 6.77 4 8.34z" })));
}
exports.default = SvgBellOffOutline;
//# sourceMappingURL=BellOffOutline.js.map